/* src/app/forms/produtos/livelo/livelo-category/livelo-category.component.scss */
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  padding-bottom: 6px;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow: auto;
  padding: 15px;
}
.pointerMenu {
  cursor: pointer;
}
/*# sourceMappingURL=livelo-category.component.css.map */
